import React from "react";
import "../../../assets/css/container/main/AboutFactWeb.css";

export default function VerificationPolicy() {
	return (
		<div className="about-container">
			<h1 className="about-title">콘텐츠 검증 기준</h1>

			<section className="about-section">
				<h2>검증의 대상</h2>
				<p>
					FactWeb은 뉴스, 주장, 발언, 통계 등
					사실 여부 판단이 가능한 정보를
					검증 대상으로 삼습니다.
				</p>
			</section>

			<section className="about-section">
				<h2>판단 기준</h2>
				<p>
					출처의 신뢰성, 1차 자료 여부,
					맥락 왜곡 여부와 복수 출처 교차 확인을 통해
					검증 판단이 이루어집니다.
				</p>
			</section>

			<section className="about-section">
				<h2>검증 결과</h2>
				<p>
					검증 결과는 사실, 부분적 사실,
					판단 보류, 허위로 구분되며,
					이는 작성 시점을 기준으로 합니다.
				</p>
			</section>

			<section className="about-section">
				<h2>유의 사항</h2>
				<p>
					새로운 정보가 등장할 경우
					검증 결과는 언제든지 변경될 수 있으며,
					FactWeb은 고정된 진실을 주장하지 않습니다.
				</p>
			</section>
		</div>
	);
}
